export default __webpack_public_path__ + "static/media/weak_bull.a9709efb.png";